import VSpeedDial from './VSpeedDial'

/* istanbul ignore next */
VSpeedDial.install = function install (Vue) {
  Vue.component(VSpeedDial.name, VSpeedDial)
}

export default VSpeedDial



// WEBPACK FOOTER //
// ./src/components/VSpeedDial/index.js